import { Component } from "react";
import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { DatePicker } from "rsuite";
import isBefore from "date-fns/isBefore";
import isAfter from "date-fns/isAfter";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";

class SearchDateBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataload: true,
      startDate: this.props.parentData.startDate,
      endDate: this.props.parentData.endDate,
      topXX: this.props.parentData.topXX,
      TypeDateArr: [
        { value: "executiondate", label: "Sign Date" },
        { value: "commencementdate", label: "Commencement Date" },
        { value: "absorptiondate", label: "Absorption Date" },
      ],
      initialValues: {
        dateType: this.props.parentData.dateType
          ? this.props.parentData.dateType
          : "executiondate",
      },
    };
  }

  handlestartSelect(start) {
    this.setState({
      startDate: start,
    });
  }
  handleendSelect(end) {
    this.setState({
      endDate: end,
    });
  }
  handleClear(ranges) {
    this.setState({
      startDate: "",
      endDate: "",
      topXX: "",
      initialValues: {
        dateType: "",
      },
    });
  }

  handleChangeDatetype(newvalue) {
    this.setState({
      initialValues: {
        dateType: newvalue.target.value,
      },
    });
  }
  handleChangeTopxx(newvalue) {
    this.setState({
      topXX: newvalue.target.value,
    });
  }
  dateConvert(dateString) {
    if (dateString != "" && dateString != "ull" && dateString != "undefined") {
      const dateArr = JSON.stringify(dateString).slice(1, 11).split("-");
      return new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
    } else {
      return null;
    }
  }
  checksubmit() {
    // console.log(dateString);
    if (
      this.state.startDate != "" &&
      this.state.startDate != "ull" &&
      this.state.startDate != "undefined" &&
      this.state.endDate != "" &&
      this.state.endDate != "ull" &&
      this.state.endDate != "undefined"
    ) {
      return true;
    } else if (
      this.state.topXX != "" &&
      this.state.topXX != "ull" &&
      this.state.topXX != "undefined" &&
      (this.state.startDate === "" ||
        this.state.startDate === "ull" ||
        this.state.startDate === "undefined") &&
      (this.state.endDate === "" ||
        this.state.endDate === "ull" ||
        this.state.endDate === "undefined")
    ) {
      return true;
    } else {
      return false;
    }
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <h4 className="searchDateModalHeading">Select Date Range</h4>
          <div className="col-lg-12">
            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values) => {
                values.startDate = JSON.stringify(
                  new Date(this.state.startDate)
                ).slice(1, 11);
                values.endDate = JSON.stringify(
                  new Date(this.state.endDate)
                ).slice(1, 11);
                values.dateType = this.state.initialValues.dateType;
                values.topXX = this.state.topXX;
                this.props.datechildFilter(values);
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <Form>
                  <div className="form-control">
                    <label>Date Type</label>
                    <Field
                      name="dateType"
                      as="select"
                      onChange={(e) => {
                        this.handleChangeDatetype(e);
                        handleChange(e);
                      }}
                    >
                      {/* <option value='' label="Select.."/> */}
                      {this.state.TypeDateArr.map((item) => (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Field>

                    <ErrorMessage name="dateType" component="div" />
                  </div>

                  <div className="form-control">
                    <div className="row">
                      <div className="col-lg-6">
                        <label>From</label>
                        <DatePicker
                          format="yyyy-MM-dd"
                          placeholder="yyyy-mm-dd"
                          oneTap={true}
                          disabledDate={(date) =>
                            isAfter(date, this.dateConvert(this.state.endDate))
                          }
                          defaultValue={this.dateConvert(this.state.startDate)}
                          // ranges={[selectionRange]}
                          onChange={(e) => {
                            this.handlestartSelect(e);
                          }}
                        />
                      </div>
                      <div className="col-lg-6">
                        <label>To</label>
                        <DatePicker
                          format="yyyy-MM-dd"
                          placeholder="yyyy-mm-dd"
                          oneTap={true}
                          disabledDate={(date) =>
                            isBefore(
                              date,
                              this.dateConvert(this.state.startDate)
                            )
                          }
                          defaultValue={this.dateConvert(this.state.endDate)}
                          // ranges={[teselectionRange]}
                          onChange={(e) => {
                            this.handleendSelect(e);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-control">
                    <label htmlFor="topXX">Top XX</label>
                    <Field
                      type="number"
                      max="50"
                      min="1"
                      id="topXX"
                      name="topXX"
                      onChange={(e) => {
                        this.handleChangeTopxx(e);
                      }}
                      value={this.state.topXX}
                    />
                    <ErrorMessage name="topXX" />
                  </div>
                  <div className="btnWrapper text-center">
                    {this.checksubmit() && <button type="submit">Apply</button>}
                    <button
                      onClick={() => {
                        this.handleClear();
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SearchDateBox);
